/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:44:29
 * @LastEditTime: 2023-02-17 14:44:51
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\intelligentize-report\fight-map\index.js
 * 作战地图
 */

import businessSaleRouter from './modules/businessSaleRouter'
import clientFolwRouter from './modules/clientFolwRouter'
const fightMapRouter = [].concat(businessSaleRouter, clientFolwRouter)

export default fightMapRouter
